/*
 * This illustrates how to modify the LoadOrdersHandler in a number of different ways.
 * The LoadOrdersHandler is used by the order history page to load order data
 */

import
{replaceInChain} from "@insite/client-framework/HandlerCreator";
import {updateCartLineWithResult as updateCartLineApi} from "@insite/client-framework/Services/CartService";
import { chain, UpdateCartLine } from "@insite/client-framework/Store/Pages/Cart/Handlers/UpdateCartLine";

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
 replaceInChain(chain, UpdateCartLine,  async props =>  
{

    const result = await updateCartLineApi(props.apiParameter);
   
        if (!result.successful && result?.errorMessage)
        {
           // Do something

        } 
  });



